import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { and } from 'ember-truth-helpers';

interface SettingsBudgetForecastTableBudgetForecastThActionsSignature {
  Args: {
    column: {
      canShowEditButton: boolean;
      collapseRows: () => void;
      editDisabledTooltipMessage?: string;
      isCollapseDisabled: boolean;
      isEditDisabled?: boolean;
      onEdit: () => void;
    };
  };
}

const SettingsBudgetForecastTableBudgetForecastThActions = <template>
  <div class="flex gap-200" data-test-id="th-actions">
    <PrismButton
      @buttonType="secondary"
      @icon="collapse-all"
      @isDisabled={{@column.isCollapseDisabled}}
      @onClick={{@column.collapseRows}}
      @size="small"
    />

    {{#if @column.canShowEditButton}}
      <div class="inline-flex">
        {{#if (and @column.isEditDisabled @column.editDisabledTooltipMessage)}}
          {{! @glint-expect-error: Incorrect type }}
          <PrismTooltip @text={{@column.editDisabledTooltipMessage}} />
        {{/if}}

        {{#unless @column.isEditDisabled}}
          <PrismTooltip
            @text={{t "settings.budget_forecast.edit_segment_visibility"}}
          />
        {{/unless}}
        <PrismButton
          @buttonType="secondary"
          @icon="edit-pencil"
          @isDisabled={{@column.isEditDisabled}}
          @onClick={{@column.onEdit}}
          @size="small"
          aria-label={{t "settings.budget_forecast.edit_segment_visibility"}}
          class="ic-product-tour-49285022-edit-segment-hierarchy-button"
          data-test-id="th-actions-edit-button"
        />
      </div>
    {{/if}}
  </div>
</template> satisfies TOC<SettingsBudgetForecastTableBudgetForecastThActionsSignature>;

export default SettingsBudgetForecastTableBudgetForecastThActions;
